import { ArrowUpRight } from "@/components/icons";
import { Button } from "@/components/ui/button";
import UpcomingEvents from "../upcoming-events";
import { AboutBasicTrainingSkeleton } from "./components/loader";
import Link from "next/link";

const AboutBasicTraning = ({
  isLoading,
  data,
  batches,
  origin,
}: {
  isLoading: boolean;
  data: any;
  batches: any;
  origin?: string;
}) => {
  if (isLoading) return <AboutBasicTrainingSkeleton />;
  return (
    <section className="container grid grid-cols-1 gap-8 py-12 lg:grid-cols-2 lg:py-32">
      <div className="flex flex-col gap-4 lg:gap-8">
        <h3 className="text-primary text-3xl font-semibold lg:text-7xl">
          {data?.title?.split(" ")[0]}{" "}
          <span className="font-vollkorn font-normal italic">
            {data?.title?.split(" ").slice(1).join(" ")}
          </span>
        </h3>
        <div
          className="prose not-prose-markers max-w-none text-base font-medium text-slate-800 lg:text-3xl"
          dangerouslySetInnerHTML={{ __html: data?.description }}
        ></div>
        <Button className="w-full rounded-full lg:w-fit" size="2xl" asChild>
          <Link href="/#faq">
            Learn More
            <ArrowUpRight className="ml-2 text-white lg:ml-3" />{" "}
          </Link>
        </Button>
      </div>
      <UpcomingEvents batches={batches} origin={origin} />
    </section>
  );
};

export default AboutBasicTraning;
